import { IFlyingCart } from "@features/cart/IFlyingCart";
import { useStyle } from "../FlyingCartLayouts/style";
import { Divider } from "@mui/material";
import { FlyingCartTotal } from "./FlyingCartTotal/FlyingCartTotal";
import { FlyingCartItems } from "./FlyingCartItems";

interface IParams {
    arePricesLoading?: boolean;
    flyingCart: IFlyingCart;
    showItems?: boolean;
}

export const FlyingCartContent = (props: IParams) => {
    const { flyingCart, showItems = true, arePricesLoading } = props;
    const { classes } = useStyle({});

    return (
        <>
            {showItems && (
                <>
                    <FlyingCartItems arePricesLoading={arePricesLoading} flyingCart={flyingCart} />
                    <Divider className={classes.flyingCartDivider} />
                </>
            )}
            <FlyingCartTotal
                arePricesLoading={arePricesLoading}
                monthlyTotal={flyingCart.totalRecurringAmount}
                oneOffTotal={flyingCart.totalUpFrontAmount}
            />
        </>
    );
};
